import { ElementNotFound } from "@senciamatch/frontend/components/ElementNotFound";
import { LoadingData } from "@senciamatch/frontend/components/LoadingData";
import { useDebounce } from "@senciamatch/frontend/hooks/useDebounce";
import { trpc } from "@senciamatch/frontend/libs/trpc";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BuildingTable } from "./table";

export const BuildingsPage: React.FC = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebounce(search, 500);
  const navigate = useNavigate();

  const getBuildings = trpc.getBuildingsSearch.useQuery({ search: debouncedSearch, page, limit: 20 });
  const getCompanies = trpc.getCompanies.useQuery();
  const getStaffs = trpc.getStaffs.useQuery();
  const getBuildingHighPriorityStaffs = trpc.getBuildingHighPriorityStaffs.useQuery();

  if (
    getBuildings.isPending ||
    getCompanies.isPending ||
    getStaffs.isPending ||
    getBuildingHighPriorityStaffs.isPending
  )
    return <LoadingData />;
  if (!getBuildings.data || !getCompanies.data || !getStaffs.data || !getBuildingHighPriorityStaffs.data)
    return <ElementNotFound />;

  return (
    <div className="h-screen flex flex-col">
      <h2 className="text-2xl font-bold py-10 flex-shrink-0">物件一覧</h2>
      <div className="overflow-x-auto py-10 bg-white border border-base-100 px-8 flex-grow flex flex-col">
        <div className="flex justify-between pb-8 flex-shrink-0">
          <div className="relative w-1/2">
            <input
              type="text"
              className="w-full border border-gray-200 rounded-md px-4 py-2"
              placeholder="物件番号 / 物件名 で検索"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
            {getBuildings.isFetching && (
              <div className="absolute right-2 top-1/2 -translate-y-1/2">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900" />
              </div>
            )}
          </div>
          <button
            type="button"
            className="bg-primary-700 text-white px-4 py-2 rounded-md"
            onClick={() => navigate("/buildings/new")}
          >
            新規登録
          </button>
        </div>
        <BuildingTable buildings={getBuildings.data.buildings} companies={getCompanies.data.companies ?? []} />
        <div className="flex justify-center mt-4 flex-row gap-8">
          <button
            type="button"
            className="join-item btn"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            «
          </button>
          <div className="flex flex-row gap-2 items-center">
            <span className="text-sm font-bold">{page}</span>
            <span className="text-sm">/</span>
            <span className="text-sm font-bold">{getBuildings.data.totalPages}</span>
          </div>

          <button
            type="button"
            className="join-item btn"
            onClick={() => setPage((p) => Math.min(getBuildings.data.totalPages, p + 1))}
            disabled={page === getBuildings.data.totalPages}
          >
            »
          </button>
        </div>
      </div>
    </div>
  );
};
